import makeApiRequest from './makeApiRequest';

const getTenders = () => {
	const getApiRequest = makeApiRequest('GET');

	const acquireTenders = async (apiBase: string) => getApiRequest(`${apiBase}/api/fair/tenders`, {});

	return [acquireTenders];
};

export default getTenders;
